import tpl from './loginWidget.html';
import "./loginWidget.css";

class loginWidget {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
        this.baseURL = '//' + window.location.host;

        let that = this;
        let fdLoginContainer = new Vue({
            el: '#fdLoginContainer',
            data: {
                visiableType: 'login',
                // visiableType: 'change',
                userError: '',
                pwdError: '',
                telephone: '',
                password: '',
                // 注册
                reUserError: '',
                reNameError: '',
                reVcodeError: '',
                rePwdError: '',
                reTelephone: '',
                reUsername: '',
                codeTxt: '获取验证码',
                reVcode: '',
                rePassword: '',
                rePasswordRepeat: '',
            },
            methods: {
                login: function() {
                    this.userError = '';
                    this.pwdError = '';
                    if (!this.telephone) {
                        this.userError = '请输入用户名！';
                        return false;
                    }
                    if (!this.password) {
                        this.pwdError = '请输入密码！';
                        return false;
                    }
                    let validateType = '';
                    let phoneTest = /^1[34578][0-9]{9}$/;
                    if (phoneTest.test(this.telephone)) {
                        validateType = 'mobile'
                    } else {
                        validateType = 'account';
                    }
                    let data = {
                        loginNum: this.telephone,
                        password: this.password,
                        validateType: validateType
                    }
                    Freedo.FdServer.FdUserServer.userLogin(data, that.baseURL, res => {
                        if (res.code === 'PU03000') {
                            this.pwdError = res.msg;
                            return false;
                        }
                        if (res.code === 'PU03010') {
                            this.userError = res.msg;
                            return false;
                        }
                        if (res.code === 'PU03012') {
                            this.userError = res.msg;
                            return false;
                        }
                        if (res.success === 1) {
                            localStorage.setItem('token', res.token);
                            localStorage.setItem('userTel', res.rows[0].mobileNum);
                            localStorage.setItem('username', res.rows[0].userName);
                            window.location.href = 'homepage.html';
                        } else {
                            this.userError = '未知原因，登录失败';
                            return false;
                        }
                    });
                },
                getVcode: function() {
                    this.reUserError = '';
                    if (!this.reTelephone) {
                        this.reUserError = '请输入手机号！';
                        return false;
                    }
                    let count = 60;
                    let interval = setInterval(() => {
                        if (count === 0) {
                            this.codeTxt = '获取验证码';
                            clearInterval(interval);
                            return false;
                        }
                        this.codeTxt = count + 's';
                        count--;
                    }, 1000)
                    let telphone = this.reTelephone;
                    Freedo.FdServer.FdUserServer.getVerificationCode(telphone, that.baseURL);
                },
                register: function() {
                    this.reUserError = '';
                    this.reNameError = '';
                    this.reVcodeError = '';
                    this.rePwdError = '';
                    let nameTest = /^[a-zA-Z0-9_]{4,16}$/;
                    if (!this.reUsername || !nameTest.test(this.reUsername)) {
                        this.reNameError = '4-12字符，只能包含英文字母、数字、下划线'
                        return false;
                    }
                    if (!this.reTelephone) {
                        this.reUserError = '请输入手机号！';
                        return false;
                    }
                    if (!this.reVcode) {
                        this.reVcodeError = '请填入验证码！';
                        return false;
                    }
                    if (!this.rePassword || !this.rePasswordRepeat) {
                        this.rePwdError = '请输入密码！';
                        return false;
                    }
                    let testPwd = /^[a-zA-Z0-9]{6,16}$/;
                    if (!testPwd.test(this.rePassword)) {
                        this.rePwdError = '密码长度为6~16位，只能包含数字、字母';
                        return false;
                    }
                    if (this.rePassword !== this.rePasswordRepeat) {
                        this.rePwdError = '两次密码不一致';
                        return false;
                    }
                    let data = {
                        telnumber: this.reTelephone,
                        password: this.rePassword,
                        verifycode: this.reVcode,
                        username: this.reUsername
                    }
                    Freedo.FdServer.FdUserServer.registerUser(data, that.baseURL, res => {
                        if (res.success === 1) {
                            localStorage.setItem('username', data.reUsername);
                            localStorage.setItem('token', res.token);
                            window.location.href = 'homepage.html';
                        } else {
                            this.reUserError = res.msg;
                        }
                    });
                },
                changePwd: function() {
                    this.reUserError = '';
                    this.reVcodeError = '';
                    this.rePwdError = '';
                    if (!this.reTelephone) {
                        this.reUserError = '请输入手机号！';
                        return false;
                    }
                    if (!this.reVcode) {
                        this.reVcodeError = '请填入验证码！';
                        return false;
                    }
                    if (!this.rePassword || !this.rePasswordRepeat) {
                        this.rePwdError = '请输入密码！';
                        return false;
                    }
                    if (this.rePassword !== this.rePasswordRepeat) {
                        this.rePwdError = '两次密码不一致';
                        return false;
                    }
                    let data = {
                        mobileNum: this.reTelephone,
                        password: this.rePassword,
                        verifyCode: this.reVcode
                    }
                    Freedo.FdServer.FdUserServer.changePassword(data, that.baseURL, res => {
                        if (res.code === 'PU05001') {
                            this.reVcodeError = '验证码超时！';
                            return false;
                        }
                        if (res.code === 'PU03010') {
                            this.reUserError = res.msg;
                            return false;
                        }
                        if (res.success === 1) {
                            this.visiableType = 'login';
                        }
                    });
                },
                reset: function() {
                    this.reUserError = '';
                    this.reNameError = '';
                    this.reVcodeError = '';
                    this.rePwdError = '';
                    this.reTelephone = '';
                    this.reVcode = '';
                    this.rePassword = '';
                    this.rePasswordRepeat = '';
                }
            },
            mounted() {
                let url = window.location.href;
                let strs = url.split("?");
                let len = strs.length;
                if(len>1) {
                    this.visiableType = 'register';
                }
                
            }
        })
    }
}

export {
    loginWidget
};